/**
 * Application Log API client.
 *
 * Sends batches of general app-log entries (uncaught errors, unhandled
 * rejections, etc.) to the shared fs-assistant FastAPI logging service
 * (POST /app-log) — see
 * fs-assistant/backend/src/fastapi/routes/app_log.py. This site has no
 * backend of its own to receive logs, so it reuses that one under its own
 * `source` stream instead of duplicating it.
 */
import { APP_LOG_ENDPOINT, APP_LOG_SOURCE } from '../config/api';

export async function sendAppLogBatch(logs) {
  if (!logs || logs.length === 0) {
    return;
  }

  const response = await fetch(APP_LOG_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ source: APP_LOG_SOURCE, logs }),
  });

  if (!response.ok) {
    const errorText = await response.text().catch(() => 'Unknown error');
    throw new Error(`HTTP ${response.status}: ${errorText}`);
  }

  return response.json();
}
